// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*  imported from Textarea-Box.module.scss  */
.Textarea-Box-module-Root_3xb {
  position: absolute;
  z-index: 1;
  /* рисуем первым уровнем, чтобы сверху класть контрол и иконки */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Textarea/Box/Textarea-Box.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,gEAAgE;EAChE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*  imported from Textarea-Box.module.scss  */\n.Textarea-Box-module-Root_3xb {\n  position: absolute;\n  z-index: 1;\n  /* рисуем первым уровнем, чтобы сверху класть контрол и иконки */\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
